(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ppd-theme-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.body;
    if (!root?.classList.contains('ppd-theme')) return;
    const key = 'ppd-storefront-mood-v1';
    const allowed = new Set(['auto', 'light', 'forest', 'twilight', 'workshop', 'custom']);
    let choice = 'auto';
    try { choice = window.localStorage.getItem(key) || 'auto'; } catch {}
    if (!allowed.has(choice)) choice = 'auto';
    const apply = (value) => {
      const mood = value === 'auto' ? root.dataset.ppdDefaultMood : value;
      root.dataset.ppdMood = mood;
      document.querySelectorAll('[data-ppd-mood-choice]').forEach((button) => {
        const selected = button.dataset.ppdMoodChoice === value;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-selected', selected);
      });
    };
    apply(choice);
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ppd-mood-choice]');
      if (!button) return;
      choice = button.dataset.ppdMoodChoice;
      try { window.localStorage.setItem(key, choice); } catch {}
      apply(choice);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
